import { useState } from 'react';
import { useAuthStore } from '../stores/authStore';

interface Props {
  children: React.ReactNode;
}

export default function TokenGate({ children }: Props) {
  const token = useAuthStore((s) => s.token);
  const rejected = useAuthStore((s) => s.rejected);
  const setToken = useAuthStore((s) => s.setToken);
  const [value, setValue] = useState('');

  if (token) return <>{children}</>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <form
        className="card w-80 space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          const t = value.trim();
          if (t) setToken(t);
        }}
      >
        <h1 className="text-lg font-bold text-gray-900">Pebbl Admin</h1>
        {rejected && (
          <div className="text-xs text-red-600">Token rejected — try again.</div>
        )}
        <input
          type="password"
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Admin token"
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        />
        <button type="submit" className="btn btn-primary w-full">
          Enter
        </button>
      </form>
    </div>
  );
}
